import './scss/main.scss'
import { create } from './js/utilities/module-loader'
import { moduleMap } from './module-map'

/**
 * Zoom App responsible for loading modules on page load
 */
export default class App {
  constructor() {
    this.modules = [] // ref to all of the instantiated module
    this.loadModules()
  }

  /**
   * Destroys all modules in the app
   */
  destroy() {
    this.modules.forEach((module) => {
      if (typeof module.destroy === 'function') {
        module.destroy()
      }
    })
  }

  /**
   * Queries the DOM elements modules on a page and instantiates
   * an instance of them if they have not yet been instantiated
   * and the associated JS module is defined
   */
  loadModules() {
    console.log(document.readyState)
    if (document.readyState === "complete" || document.readyState === "loaded" || document.readyState === "interactive") {
      create(moduleMap).then((modules) => {
        this.modules.push(modules)
      })
    } 
    document.addEventListener("DOMContentLoaded", function() {
      create(moduleMap).then((modules) => {
        this.modules?.push(modules)
      })
    });

  }
}
